import { serverFlagKey } from '~/composables/useServerFlag';

/**
 * A flag for route middleware, answered the way the pages answer it. `useServerFlag` carries the
 * server's answer to the browser in the payload; middleware runs outside a component, so it reads
 * that answer when a page has already asked, and only otherwise asks the flag provider. Without
 * this, a browser whose provider falls back to the static bootstrap (Unleash blocked) would take a
 * different route from the page it is navigating within.
 *
 * It reads the payload directly rather than through `useNuxtData`: middleware runs in the app's own
 * scope, so a `useNuxtData` there would hold the answer for the rest of the session.
 */
export const serverFlagAnswer = (flagName: string): Promise<boolean> => {
  const answer = useNuxtApp().payload.data[serverFlagKey(flagName)];
  if (typeof answer === 'boolean') {
    return Promise.resolve(answer);
  }

  return useFeatureFlags().getFlag(flagName);
};
